import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'



interface SearchState {
  lastName: string;
  bookingDate: string;
  releaseDate: string;
  searchDescription: string | null;
}

const initialState: SearchState = {
  lastName: '',
  bookingDate: '',
  releaseDate: '',
  searchDescription: null,
}

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload
    },
    setBookingDate: (state, action: PayloadAction<string>) => {
      state.bookingDate = action.payload
    },
    setReleaseDate: (state, action: PayloadAction<string>) => {
      state.releaseDate = action.payload
    },
    setSearchDescription: (state, action: PayloadAction<string>) => {
      state.searchDescription = action.payload
    },
    clearForm: (state) => {
      state.lastName = ''
      state.bookingDate = ''
      state.releaseDate = ''
    },
  }
})

export const { setLastName, setBookingDate, setReleaseDate, setSearchDescription, clearForm } = searchSlice.actions

export const selectLastName = (state: RootState) => state.search.lastName
export const selectBookingDate = (state: RootState) => state.search.bookingDate
export const selectReleaseDate = (state: RootState) => state.search.releaseDate
export const selectSearchDescription = (state: RootState) => state.search.searchDescription

export default searchSlice.reducer